import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { $tk } from 'utils/appTranslationKey';

import { AddPromotionOverviewFC, AddPromotionOverviewFCProps } from './AddPromotionOverviewFC';

const useStrings = (): AddPromotionOverviewFCProps['strings'] => {
  const intl = useIntl();

  return useMemo(
    () => ({
      title: intl.formatMessage({ id: $tk.components.PromotionOverview.title }),
      tncWithConsent: intl.formatMessage({ id: $tk.components.PromotionOverview.tncWithConsent }),

      back: intl.formatMessage({ id: $tk.buttons.back }),

      publish: intl.formatMessage({ id: $tk.components.PromotionSummary.publish }),
      durationTitle: intl.formatMessage({ id: $tk.components.PromotionSummary.durationTitle }),
      exampleBasePrice: intl.formatMessage({
        id: $tk.components.PromotionSummary.exampleBasePrice,
      }),
      exampleDescription: intl.formatMessage({
        id: $tk.components.PromotionSummary.exampleDescription,
      }),
      exampleDiscountedPrice: intl.formatMessage({
        id: $tk.components.PromotionSummary.exampleDiscountedPrice,
      }),
      exampleTitle: intl.formatMessage({ id: $tk.components.PromotionSummary.exampleTitle }),
      exampleTooltip: intl.formatMessage({ id: $tk.components.PromotionSummary.exampleTooltip }),
      exampleType: intl.formatMessage({ id: $tk.components.PromotionSummary.exampleType }),
      promotionTitle: intl.formatMessage({ id: $tk.components.PromotionSummary.promotionTitle }),
      appliesToItemsTitle: intl.formatMessage({
        id: $tk.components.PromotionSummary.appliesToItemsTitle,
      }),
      viewAll: intl.formatMessage({ id: $tk.components.PromotionSummary.viewAll }),
      promotionVisibilityDisclaimer: intl.formatMessage({
        id: $tk.components.PromotionSummary.promotionVisibilityDisclaimer,
      }),
    }),
    [intl],
  );
};

type AddPromotionOverviewProps = Omit<AddPromotionOverviewFCProps, 'strings'>;

export function AddPromotionOverview(props: AddPromotionOverviewProps) {
  const strings = useStrings();
  return <AddPromotionOverviewFC {...props} strings={strings} />;
}
